import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
    const [items, setItems] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem("sgs_cart") || "[]");
        } catch {
            return [];
        }
    });
    const [open, setOpen] = useState(false);

    useEffect(() => {
        localStorage.setItem("sgs_cart", JSON.stringify(items));
    }, [items]);

    const addItem = (product, qty = 1) => {
        setItems((prev) => {
            const existing = prev.find((i) => i.id === product.id);
            if (existing) {
                return prev.map((i) => (i.id === product.id ? { ...i, qty: i.qty + qty } : i));
            }
            return [
                ...prev,
                { id: product.id, slug: product.slug, name: product.name, image: product.image, category: product.category, qty },
            ];
        });
        setOpen(true);
    };

    const setQty = (id, qty) => {
        if (qty < 1) return;
        setItems((prev) => prev.map((i) => (i.id === id ? { ...i, qty } : i)));
    };

    const removeItem = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
    const clear = () => setItems([]);

    const count = useMemo(() => items.reduce((sum, i) => sum + i.qty, 0), [items]);

    return (
        <CartContext.Provider value={{ items, addItem, setQty, removeItem, clear, count, open, setOpen }}>
            {children}
        </CartContext.Provider>
    );
};
